import React, { FC } from 'react';

import { Button, Container, ContainerProps } from '@lglp/components';
import { SearchMenu } from '@lglp/prismic-client';

import Link from '../../../components/library/Link';
import { SearchIcon } from '../../Icons';
import { StyledButton } from '../../StyledButton';
import styles from './MenuRechercher.module.scss';

export const MenuRechercher: FC<MenuRechercherProps> = ({
  search,
  className,
}) => {
  const { label, link } = search;
  return (
    <Container className={[styles.container, className]}>
      <StyledButton className={[styles.button]} as={Link} {...link}>
        <Button.Label>{label}</Button.Label>
        <SearchIcon className={styles.icon} />
      </StyledButton>
    </Container>
  );
};

type MenuRechercherProps = ContainerProps & {
  search: SearchMenu;
};
